import { Footer as TameeniFooter } from '@tameeni/footer'
import { Icon } from '@tameeni/icons'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@tameeni/ui'
import { Link } from 'react-router-dom'
import { useFooter } from '@/features/main-layout/hooks/use-footer'
import { useCurrentLocale, useScopedI18n } from '@/locales/client'

export default function Footer() {
  const locale = useCurrentLocale()
  const t = useScopedI18n('common.links')
  const { menuItems } = useFooter()

  return (
    <TameeniFooter
      copyRightsText={t('copyRightsText')}
      downloadAppLabel={t('downloadTameeniApp')}
      followUsLabel={t('followTameeni')}
      locale={locale}
      poweredByLabel={t('poweredBy')}
      tameeniLogo={
        <Link to={`/${locale}`}>
          <Icon
            className='h-9 w-[165px] text-primary rtl:w-[113px]'
            name={locale === 'ar' ? 'TameeniLogoAR' : 'TameeniLogoEN'}
          />
        </Link>
      }
    >
      <>
        <nav className='flex flex-col gap-4 border-b border-slate-300 py-2 xl:hidden'>
          <Accordion className='w-full' collapsible type='single'>
            {menuItems.map((section) => (
              <AccordionItem
                key={section.label}
                className='border-b-0'
                value={section.label}
              >
                <AccordionTrigger className='text-md py-2 font-semibold'>
                  {section.label}
                </AccordionTrigger>
                <AccordionContent className='flex flex-col gap-4 text-balance'>
                  <ul className='space-y-4 text-muted-foreground'>
                    {section.items.map((item) => (
                      <li
                        key={item.label}
                        className='ps-1 text-sm font-normal text-slate-600 hover:text-primary'
                      >
                        <Link to={item.link}>{item.label}</Link>
                      </li>
                    ))}
                  </ul>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </nav>
        <nav className='hidden grow justify-between gap-16 xl:flex'>
          {menuItems.map((section) => (
            <div key={section.label}>
              <h3 className='text-md mb-6 font-semibold text-slate-900'>
                {section.label}
              </h3>
              <ul className='grid grid-flow-col grid-rows-5 gap-x-12 gap-y-4 text-muted-foreground'>
                {section.items.map((item) => (
                  <li
                    key={item.label}
                    className='ps-1 text-sm font-normal text-slate-600 hover:text-primary'
                  >
                    <Link to={item.link}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </>
    </TameeniFooter>
  )
}
